import React, { useEffect, useState } from 'react';
import { Table } from '..';
import {
  PAYMENT_ORDERS_HEADERS,
  PAYMENT_ORDER_GROUPS_HEADERS,
} from '../../constants/table-headers';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../Pagination';
import './styles.scss';
import Modals from '../Modal';
import useApprovePaymentOrderGroup from '../../hooks/payment-order-groups/useApprovePaymentOrderGroup';
import useGetPaymentOrderGroups, {
  useGetPaymentOrderGroupsResponse,
  useGetPaymentOrderGroupsResponseRow,
} from '../../hooks/payment-order-groups/useGetPaymentOrderGroups';
import { Button, Grid } from '@material-ui/core';
import { checkAdmin } from '../../services/validation';
import { useSelector } from 'react-redux';
import useCreatePaymentOrderGroups from '../../hooks/payment-order-groups/useCreatePaymentOrderGroups';
import { ApplicationState } from '../../store';
import { Modal } from 'react-bootstrap';
import { GetPaymentOrdersResponseRow } from '../../hooks/payment-orders/useGetPaymentOrders';
import BoxWrapper from '../atoms/boxWrapper';

const TablePaymentOrderGroups: React.FC = () => {
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const { execute: createPaymentOrderGroups } = useCreatePaymentOrderGroups();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [refreshTable, setRefreshTable] = useState<number>(0);
  const [showPaymentOrdersModal, setShowPaymentOrdersModal] =
    useState<string>('');
  const [paymentOrderGroups, setPaymentOrderGroups] =
    useState<useGetPaymentOrderGroupsResponse>({
      rows: [],
      totalRecords: 0,
      page: '1',
    });
  const { execute: cancelPaymentOrderNfe } = useApprovePaymentOrderGroup();
  const [callback, setCallback] = useState<{
    message?: string;
    image?: string;
    callback?: () => void;
  }>({ message: '', callback: () => null });
  const { execute, loading } = useGetPaymentOrderGroups();
  const [isModal, setIsModal] = useState<boolean>(false);

  const onCancelNfe = (paymentOrderId: string) => {
    const image = paymentOrderGroups.rows
      .find(cart => cart.paymentOrderGroupId === showPaymentOrdersModal)
      ?.paymentOrders.find(
        (paymentOrder: GetPaymentOrdersResponseRow) =>
          paymentOrder.paymentOrderId === paymentOrderId,
      )?.nfeUrl;
    if (!image) {
      console.error('Invalid image URL provided');
      return;
    }

    if (
      image &&
      typeof image == 'string' &&
      (image as string)?.endsWith('.pdf')
    ) {
      return window.open(`${image}?${new Date().getTime()}`, '_blank');
    }

    setIsModal(true);
    setCallback({
      image,
    });
  };

  const onApprovePaymentOrderGroup = (paymentOrderId: string) => {
    setIsModal(true);
    setCallback({
      callback: async () => {
        await cancelPaymentOrderNfe(paymentOrderId);
        setPaymentOrderGroups(prevCarts => {
          const newCarts = prevCarts.rows.map(
            (oldPaymentOrder: useGetPaymentOrderGroupsResponseRow) => {
              if (paymentOrderId === oldPaymentOrder.paymentOrderGroupId) {
                return {
                  ...oldPaymentOrder,
                  paidAt: new Date(),
                };
              }
              return oldPaymentOrder;
            },
          );
          return {
            ...prevCarts,
            rows: newCarts,
          };
        });
      },
      message: 'Deseja aprovar essa ordem de pagamento?',
    });
  };

  useEffect(() => {
    const loading = async () => {
      const result = await execute({ page: currentPage, rowsPerPage: 20 });
      if (!result) return;
      setPaymentOrderGroups(result);
    };
    loading();
  }, [currentPage, refreshTable]);

  if (loading) {
    return <ActivityIndicator />;
  }
  return (
    <>
      <Grid
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '1rem',
        }}
      >
        {checkAdmin(token) && (
          <Button
            onClick={async () => {
              await createPaymentOrderGroups();
              setRefreshTable(refreshTable + 1);
            }}
            className="primary-button"
          >
            Gerar Ordens de Pagamento
          </Button>
        )}
      </Grid>
      <BoxWrapper>
        <Modals
          outlined
          style={{
            zIndex: 9999,
          }}
          onHide={() => {
            setIsModal(false);
          }}
          show={isModal}
          onConfirmClick={callback.callback}
          message={callback.message}
          imgSrc={callback.image}
        />
        <Modal
          centered
          size="xl"
          style={{
            zIndex: 9998,
          }}
          show={showPaymentOrdersModal !== ''}
          onHide={() => setShowPaymentOrdersModal('')}
          className="forgot-password-modal"
        >
          <Modal.Header closeButton>
            <h5>Ordens de Pagamento</h5>
          </Modal.Header>
          <Modal.Body>
            <Table
              onCancelNfe={onCancelNfe}
              columns={PAYMENT_ORDERS_HEADERS}
              data={
                paymentOrderGroups.rows.find(
                  row => row.paymentOrderGroupId === showPaymentOrdersModal,
                )?.paymentOrders || []
              }
            />
          </Modal.Body>
        </Modal>
        <div className="container-table-paymentOrders">
          {/* <div style={{ display: 'flex' }}>
          <FormControl
            style={{
              width: '10%',
              marginTop: '2%',
              display: 'flex',
              justifyItems: 'flex-end',
            }}
            variant="outlined"
          >
            <InputLabel id="select-label-freight-status">Status</InputLabel>
            <Select
              labelId="select-label-freight-status"
              style={{ width: '230%', height: '80%' }}
              id="demo-simple-select"
              label="Status"
              value={status}
              onChange={event =>
                setStatus(event.target.value as string)
              }
            >
              {[["Todos", "Todos"]].concat(Object.entries(PaymentOrderStatus)).map(([key, value]) => (
                <MenuItem key={key} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}
          <Table
            columns={PAYMENT_ORDER_GROUPS_HEADERS}
            data={paymentOrderGroups.rows}
            onExpandRows={setShowPaymentOrdersModal}
            onApprovePaymentOrderGroup={onApprovePaymentOrderGroup}
            notShowInput={true}
          />
          <Pagination
            totalRecords={paymentOrderGroups.totalRecords}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            rowsPerPage={20}
          />
        </div>
      </BoxWrapper>
    </>
  );
};

export default TablePaymentOrderGroups;
